import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'glxy-in-page-nav',
  templateUrl: './page-nav.component.html',
  styleUrls: ['./page-nav.component.scss'],
  standalone: false,
})
export class PageNavComponent implements OnDestroy {
  @HostBinding('class') class = 'glxy-in-page-nav';
  @ViewChild('pageNav') pageNav?: MatSidenav;

  /** Override the label of the mobile nav toggle button. Default: "Contents" */
  @Input() toggleLabel?: string;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    window.addEventListener('resize', this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this._mobileQueryListener);
  }

  togglePageNav(): void {
    this.pageNav?.toggle();
  }
}
